import toastr from 'toastr'

const DEFAULT_CONFIG = {
  closeButton: true,
  progressBar: true,
  positionClass: 'toast-top-right',
  preventDuplicates: true,
  showDuration: '300',
  hideDuration: '1000',
  timeOut: '5000',
  extendedTimeOut: '1000',
  showEasing: 'swing',
  hideEasing: 'linear',
  showMethod: 'fadeIn',
  hideMethod: 'fadeOut'
}

function showSuccessNotification(message) {
  toastr.success(message, 'Sucesso', DEFAULT_CONFIG)
}

function showErrorNotification(message) {
  toastr.error(message, 'Erro', DEFAULT_CONFIG)
}

export { showSuccessNotification, showErrorNotification }
